import { ctaTranslate } from "../lib/ctaTranslate";
import type { EmailFormData } from "../types";
import { FormShell } from "./_form";

interface Props {
  data: EmailFormData;
  sessionToken: string;
}

export default function EmailFormCard({ data, sessionToken }: Props) {
  return (
    <FormShell
      title={data.title}
      subtitle={data.subtitle}
      fields={data.fields}
      submitLabel={data.submitLabel}
      onSubmit={(values) => {
        const orderNumber = data.context?.orderNumber || "";
        const email = values.email || "";
        void ctaTranslate({
          code: "email_verify.track_order_with_email",
          params: { orderNumber, email },
          sessionToken,
          fallback: orderNumber
            ? `Track order ${orderNumber} with email ${email}`
            : `Use my email ${email} for tracking.`,
        });
      }}
    />
  );
}
